<div class="ap-flex ap-flex-grow-1 ap-flex-column ap-text-align-center ap-padding-top-6 ap-padding-bottom-1">
    <h2>{{ 'conversational.chat.retryconnectionerror.title' | apContent }}</h2>
    <ap-panel type="primary" aria-live="assertive">
        <p ap-panel-body class="ap-text-align-center">
            {{ 'conversational.chat.retryconnectionerror.message' | apContent }}
        </p>
    </ap-panel>
    <ap-button
        class="ap-align-content-end ap-margin-bottom-4 ap-margin-left-0"
        ariaLabel="{{ 'conversational.chat.retryconnectionerror.button' | apContent }}"
        (click)="setRefreshComponent()"
    >
        {{ 'conversational.chat.retryconnectionerror.button' | apContent }}
    </ap-button>
</div>
